
    import {
        Vue,
        Component,
        Prop,
        Emit,
        Model,
    } from 'vue-property-decorator';

    @Component
    export default class RadioInput extends Vue {
        @Model('change', { type: [String, Number] }) readonly model!: string | number;

        @Prop() readonly label!: string;

        @Prop() readonly value!: string;

        @Prop() readonly name!: string;

        @Prop() readonly checkBoxSize!: string;

        @Emit('change')
        updateInput(): string {
            return this.value;
        }

        get isChecked(): boolean {
            return this.value === this.model;
        }
    }

